export * from './se-puede-eliminar.directive';
export * from './se-puede-modificar.directive';
